import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { ActionLogItem } from '../../models/action-log.model';

export type ActionLogState = {
  actions: ActionLogItem[];
};

const initialState: ActionLogState = {
  actions: [],
};

export const ActionLogStore = signalStore(
  withState(initialState),
  withComputed((store) => ({
    byType: computed(() => {
      return (type: string) => store.actions().filter((a) => a.actionType === type);
    }),
    getMostRecentByType: computed(() => {
      return (type: string): ActionLogItem | undefined => {
        const actions = Array.isArray(store.actions()) ? store.actions() : [];
        return actions
          .filter((a) => a.actionType === type)
          .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())[0];
      };
    }),
  })),
  withMethods((store) => ({
    setActions: (actions: ActionLogItem[]) => patchState(store, { actions }),
    reset: () => patchState(store, initialState),
  }))
);
